export default [{
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
      path: '/',
      component: resolve => require(['@/components/home/view/home.vue'], resolve) //500
    }]
}]



// WEBPACK FOOTER //
// ./src/components/home/router/router.js